import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import automationKeys from '@/api/queries/automations/keyFactory';
import { graphql } from '@/gql';
import {
  CreateAutomationMutation,
  CreateAutomationMutationVariables,
} from '@/gql/graphql';

const CreateAutomation = graphql(`
  mutation CreateAutomation($input: CreateAutomationInput!) {
    createAutomation(input: $input) {
      id
      privateId
    }
  }
`);

const useCreateAutomation = (
  options?: UseMutationOptions<
    CreateAutomationMutation,
    unknown,
    CreateAutomationMutationVariables['input']
  >
) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options ?? {};
  return useMutation({
    mutationFn: (input) => gqlClient.request(CreateAutomation, { input }),
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries({
        queryKey: automationKeys.automations(),
      });
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useCreateAutomation;
